const subscribeFormUrl = (
  "https://kingstonlabs.us20.list-manage.com/subscribe/post?" +
  "u=b77b11c2932dae0acd8d12e12&amp;id=56daafc23c"
)
const typeFormIdeaLabUrl = "https://tom-kingston.typeform.com/to/DLznIx"

export {subscribeFormUrl, typeFormIdeaLabUrl}
